export default __webpack_public_path__ + "static/media/Ruins_of_Endion.f44fd590.jpg";